import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCreditCard2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconCreditCard2"><Path fillRule="evenodd" clipRule="evenodd" d="M21.99 4.00293H2V9H21.9961V10.5H2V19.9961H21.9961L21.9961 9.05303C21.9962 7.61979 21.9964 6.18525 21.9922 4.75075L21.99 4.00293ZM6 12.5V14H10.5V12.5H6Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCreditCard2;
